import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Layout from "./layout";
import LayoutDashboard from "./layout/layout";
import Table from "components/table/table";
import { useEffect, useState } from "react";
import FormDinamic from "./cadEditDinamic";
import PerfilService from "../../services/PerfilService";
import { set } from "lodash";
import { toast } from "react-toastify";

const AttachmentsPosts = ({
  tipoTela,
  dados,
  anexos,
  setAnexos,
} : any) => {

  const urlBaseApi = process.env.REACT_APP_BACKEND_API_URL;

  const [loading, setLoading] = useState(false);
  const [pathAttachment, setPathAttachment] = useState("");

  useEffect(() => {
    let caminhoAnexo = "/storage/images/posts/events/attachments/";

    if (tipoTela == 1) {
      caminhoAnexo = "/storage/images/posts/tips/attachments/";
    }

    if (tipoTela == 2) {
      caminhoAnexo = "/storage/images/posts/classifieds/attachments/";
    }

    if (tipoTela == 3) {
      caminhoAnexo = "/storage/images/posts/partnerships/attachments/";
    }

    if (tipoTela == 4) {
      caminhoAnexo = "/storage/images/posts/events/attachments/";
    }
    setPathAttachment(caminhoAnexo);
  }, [tipoTela]);

  const executarFileInput = () => {
    // pegando o input file com id attachment e type file
    const fileInput = document.getElementById("attachement") as HTMLInputElement;
    fileInput?.click();
  };

  const removerAnexo = async (attachment: any) => {
    let caminhoFile = "";

    if (tipoTela == 1) {
      caminhoFile = `/posts/tips/${attachment.id}/attachment/remove`;
    }

    if (tipoTela == 2) {
      caminhoFile = `/posts/classifieds/${attachment.id}/attachment/remove`;
    }

    if (tipoTela == 3) {
      caminhoFile = `/posts/partnerships/${attachment.id}/attachment/remove`;
    }

    if (tipoTela == 4) {
      caminhoFile = `/posts/events/${attachment.id}/attachment/remove`;
    }

    await PerfilService.removeFile(caminhoFile)
      .then((response: any) => {
        let newList = anexos.filter((item: any) => item.id != attachment.id);
        setAnexos(newList);

        toast.success("Anexo removido com sucesso!");
      })
      .catch((error: any) => {
        //console.error("veio pra ca: ", error);
      });
  };

  const onChangeAnexo = async (e: any) => {
    const reader = new FileReader();
    const files = e.target.files;

    if (files.length === 0) {
      return;
    }

    let NewListAnexos: any = anexos;
    setAnexos(null);

    let attachment = {
      attachment: {
        file: files[0],
      },
    };

    let caminhoFile = "";

    if (tipoTela == 1) {
      caminhoFile = `/posts/tips/${dados.id}/attachment/upload`;
    }

    if (tipoTela == 2) {
      caminhoFile = `/posts/classifieds/${dados.id}/attachment/upload`;
    }

    if (tipoTela == 3) {
      caminhoFile = `/posts/partnerships/${dados.id}/attachment/upload`;
    }

    if (tipoTela == 4) {
      caminhoFile = `/posts/events/${dados.id}/attachment/upload`;
    }

    await PerfilService.uploadFile(attachment, caminhoFile)
      .then((response: any) => {
        if (response.id != undefined) {
          NewListAnexos.push(response);
          setAnexos(NewListAnexos);
          toast.success("Anexo enviado com sucesso!");
        } else {
          // alert(response.response.data.message);
          toast.error(response.response.data.message);
        }
      })
      .catch((error: any) => {
        //console.error("veio pra ca: ", error);
      });

    // reader.onload = async function () {};

    // reader.readAsDataURL(files[0]);

    // setAnexo(files[0]);
    // handleChange(fieldName, files[0]);
  };

  return (
    <>
      <h3>Lista de anexos</h3>
      <div className="gap-6 mt-4" style={{ display: "flex", flexWrap: "wrap" }}>
        {anexos &&
          anexos.map((attachment: any) => (
            <>
              <div className="centralizarAnexo">
                <div className="m-1 wil-avatar relative flex-shrink-0 inline-flex items-center justify-center overflow-hidden text-neutral-100 uppercase font-semibold rounded-lg w-10 h-20 text-xl lg:text-2xl lg:w-32 lg:h-32 ring-4 ring-white shadow-2xl z-0">
                  <img
                    alt="Avatar"
                    src={urlBaseApi + pathAttachment + attachment.path}
                    className="object-cover"
                  />
                </div>
                <ButtonPrimary
                  className="m-2 shadow-2xl z-0 p-0"
                  type="button"
                  onClick={() => removerAnexo(attachment)}
                >
                  <span className="text-xs">Remover</span>
                </ButtonPrimary>
              </div>
            </>
          ))}
        <input
          id="attachement"
          type="file"
          style={{ display: "none" }}
          onChange={onChangeAnexo}
        />
        <div className="my-auto">
          <ButtonPrimary
            className="text-xl shadow-2xl w-[50px]"
            type="button"
            onClick={executarFileInput}
          >
            +
          </ButtonPrimary>
        </div>
      </div>
      <br />
    </>
  );
};

export default AttachmentsPosts;